import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import Button from '../../../../../Button'
import { QA_NAME_LISTING_PROFILE_MANAGE_PUBLISHING_BTN } from '../RentalPortalListingProfileWidgetPublishing.constants'

import * as styles from './ListingProfileWidgetPublishingManageButton.module.css'

import ChevronRightIcon from '../../../../../../icons/chevrons/right.svg'

function ListingProfileWidgetPublishingManageButton({
  isDisabled,
  tooltipKey,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <Button.Text
      afterIconProps={{ Icon: ChevronRightIcon }}
      className={styles.ListingProfileWidgetPublishingManageButton}
      disabled={isDisabled}
      qaName={QA_NAME_LISTING_PROFILE_MANAGE_PUBLISHING_BTN}
      text={t('RentalPortal.ListingProfileManagePublishingBtnKey')}
      tooltip={tooltipKey ? t(tooltipKey) : null}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={onClick}
    />
  )
}

export default ListingProfileWidgetPublishingManageButton
